// src/services/filterService.ts
import { apiService } from './api';
import type { FilterOption } from '../types/dashboard';
import type { ConversationDetail } from '../types/conversation';

export interface SearchFilterParams {
  SearchText: string;
  Filters: string;
  PageNumber: number;
  PageSize: number;
  ConfigValueId2?: number;
  Project?: number;
  CustomFields?: Array<{
    Name: string;
    FieldTypeId: number | null;
    Value: string;
    ComparisonOperator: string;
  }>;
  [key: string]: unknown;
}

export interface GetFilterOptionsParams {
  Filter?: string;
  IsFromProject?: boolean;
  ConfigValueId?: number;
}

class FilterService
{
  /**
   * Obtiene el un listado de filtros segun una cadena
   */
  async getFilterOptions(
    searchFilter: string | null,
    params?: GetFilterOptionsParams,
  ): Promise<FilterOption[]>
  {
    try
    {
      const isFromProject = params?.IsFromProject ?? true;
      const configValueId = params?.ConfigValueId ?? 1;
      let url = `/filter/GetFilterOptions?IsFromProject=${isFromProject}&ConfigValueId=${configValueId}`;
      const filterValue = params?.Filter ?? searchFilter;
      if (filterValue && filterValue.length > 0)
      {
        url += `&filter=${encodeURIComponent(filterValue)}`;
      }
      const response = await apiService.get<FilterOption[]>(url);
      return response;
    }
    catch (error)
    {
      console.error('Error getting filter options:', error);
      throw error;
    }
  }

  /**
   * Search conversations by filter criteria
   */
  async getConversationsBySearchFilter(
    requestParams: SearchFilterParams,
  ): Promise<ConversationDetail[]>
  {
    try
    {
      const response = await apiService.post<ConversationDetail[]>(
        '/conversation/GetConversationsBySearchFilter',
        requestParams,
        {
          timeout: 0,
        },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error getting conversations by search filter:', error);
      throw error;
    }
  }

  /**
   * Save search result to dashboard
   */
  async addResultToDashboard(requestParams: SearchFilterParams): Promise<any>
  {
    try
    {
      const response = await apiService.post('/conversation/SaveSearchResult', requestParams);
      return response;
    }
    catch (error)
    {
      console.error('Error saving search result to dashboard:', error);
      throw error;
    }
  }
}

export const filterService = new FilterService();
